import { render, staticRenderFns } from "./newUsers.vue?vue&type=template&id=349a83af&lang=pug&"
import script from "./newUsers.vue?vue&type=script&lang=ts&"
export * from "./newUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports